import { CommonModule } from '@angular/common';
import { Component, Input, Provider, TemplateRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';

const NP_MC_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NpMultiCheckboxComponent),
  multi: true,
};

@Component({
  selector: 'np-multi-checkbox',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './np-multi-checkbox.component.html',
  styleUrl: './np-multi-checkbox.component.scss',
  providers: [NP_MC_CONTROL_VALUE_ACCESSOR]
})
export class NpMultiCheckboxComponent implements ControlValueAccessor {

  uuid = uuidv4();

  @Input()
  customTemplate?: TemplateRef<any>;

  @Input()
  valuePath: string = 'id';

  @Input()
  textPath: string = 'text';

  @Input()
  minWidth: string = '';

  private _items: any;

  @Input()
  public get items(): any {
    return this._items;
  }
  public set items(value: any) {
    this._items = value;
  }

  disabled: boolean = false;

  value: any[] = [];

  selected: any = {};
  select(value: string) {
    this.selected[value] = !this.selected[value];

    this.value = Object.keys(this.selected).filter(k => this.selected[k] === true);
    this.onTouched();
    this.onChanged(this.value);
  }

  private onChanged!: Function;
  private onTouched!: Function;

  constructor() { }

  ngOnInit(): void {
  }

  writeValue(value: any): void {
    if (value) {
      this.selected = {};
      value.forEach((v: any) => {
        this.selected[v] = true;
      });
      this.value = value;
    } else {
      this.selected = {};
      this.value = [];
    }

  }
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public get npmcContext() {
    return {
      data: {
        disabled: this.disabled,
        items: this.items,
        selected: this.selected,
        select: (value: any) => {
          this.select(value);
        },
        uuid : this.uuid
      }
    }
  }

}
